<template><div><h1 id="anredesets" tabindex="-1"><a class="header-anchor" href="#anredesets"><span>Anredesets</span></a></h1>
<p>Anredesets — Definiert Anredesets</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient zur Steuerung der Einzel- und Haushaltsanreden. Für die Definition von Anreden können Anredesets für die situationsabhängige Anrede definiert werden. Z.B. bei einem Spendenaufruf kann für die Briefanrede &quot;Liebe Spender&quot; definiert werden und bei einem Mitgliedermailing kann die Briefanrede &quot;Liebe Mitglieder&quot; lauten. In dieser Tabelle definierte Anredesets können später z.B. in der Segmentierung oder in der Zusagenfakturierung ausgewählt werden.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Anreden</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Anredeset</dt>
<dd>Bezeichnung des Anredesets (kurze Bezeichnung).</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Anredesets (längere Beschreibung).</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="n-a" tabindex="-1"><a class="header-anchor" href="#n-a"><span>N/A</span></a></h3>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.anreden.html" title="Einzelanreden">Einzelanreden</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblhhanreden.html" title="Haushaltsanreden">Haushaltsanreden</RouteLink></p>
</div></template>


